import { getAnalyticsActor, posthog } from './posthog'

/**
 * Lối vào mở popup QR vùng trồng. Bốn màn dùng chung đúng một popup, nên không
 * có `entry` thì mọi màn dồn vào một con số và không biết màn nào đang bị chặn.
 */
export type GrowerAreaQrEntry =
    'grower_detail' | 'grower_edit' | 'my_grower_detail' | 'grower_dashboard'

/**
 * Kết quả người dùng THẬT SỰ nhận được khi mở popup, không phải chỉ "đã mở":
 *   - `code_ready`: ra mã quét được — mã cân chè (SĐT hộ ghép mã vùng) hoặc
 *     mã cắm vùng (đường dẫn trang vùng), phân biệt bằng `qr_kind`.
 *   - `missing_phone` / `missing_area_code`: hai nửa nội dung mã cân chè, thiếu
 *     nửa nào thì không dựng mã — hai việc phải sửa ở hai chỗ khác nhau. Mã cắm
 *     vùng không cần hai thứ này nên không bao giờ ra hai kết quả đó.
 *   - `pick_area`: hộ nhiều thửa, đang phải chọn vùng và chưa ra mã.
 *   - `no_area` / `unsaved_area` / `load_error`: ba lý do không có mã, cố ý tách
 *     riêng vì cách xử lý khác nhau hoàn toàn.
 */
export type GrowerAreaQrOutcome =
    | 'code_ready'
    | 'missing_phone'
    | 'missing_area_code'
    | 'pick_area'
    | 'no_area'
    | 'unsaved_area'
    | 'load_error'

/**
 * Loại mã người dùng đang xem khi đạt tới kết quả (M-84):
 *   - `scale`: mã cân chè — SĐT hộ ghép mã vùng, quét ở cân điện tử.
 *   - `field_link`: mã cắm vùng — đường dẫn trang chi tiết vùng, in ra cắm ở thửa.
 *   - `none`: kết quả nằm ngoài màn mã (chọn vùng, chưa có vùng, lỗi tải…),
 *     chưa có tab nào để chọn.
 */
export type GrowerAreaQrKind = 'scale' | 'field_link' | 'none'

/**
 * Mức dùng và kết quả của popup QR vùng trồng.
 *
 * KHÔNG gửi số điện thoại hộ, mã vùng, nội dung mã QR, id hộ/vùng hay tên hộ:
 * nội dung mã chính là PII của hộ. Chỉ gửi enum + đếm số vùng.
 * Analytics lỗi hoặc tắt không được chặn việc lấy mã.
 */
export function captureGrowerAreaQrAction(input: {
    entry: GrowerAreaQrEntry
    outcome: GrowerAreaQrOutcome
    /** Số vùng ĐÃ LƯU của hộ — đếm, không kèm id hay mã vùng. */
    savedAreas: number
    /** Người dùng có phải tự chọn vùng trước khi tới kết quả này hay không. */
    picked: boolean
    qrKind: GrowerAreaQrKind
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('grower_area_qr_action', {
            schema_version: 2,
            event_id: crypto.randomUUID(),
            ...actor,
            entry: input.entry,
            outcome: input.outcome,
            saved_areas: input.savedAreas,
            picked: input.picked,
            qr_kind: input.qrKind,
        })
    } catch {
        // Analytics không được chặn việc lấy mã QR vùng trồng.
    }
}
